export default __webpack_public_path__ + "static/media/active-citizens-fund-logo.910aa9a8.png";